<template>
	<div>
		<common-header></common-header>
		<div class="container">
			<template v-if="cartList.length">
				<el-table
					ref="multipleTable"
					:data="cartList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="id"
					:stripe="true"
					@select="rowSelect"
					@select-all="selectAll"
					tooltip-effect="dark"
					:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
				>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="goodsinfo" label="商品信息" width="400">
						<template slot-scope="scope">
							<div class="flex">
								<div class="goods-info flex">
									<el-image :src="getWebPic(scope.row.smpic)" lazy></el-image>
									<div class="title flex" style="flex-direction: column;">
										<div class="title-name" @click="toPage('/goods/goodsDetail', 'id='+scope.row.goods_id)">{{ scope.row.name }}</div>
										<div class="param">
											<span>{{ scope.row.param1 }}</span>
											<span style="margin-left: 10px;">{{ scope.row.param2 }}</span>
										</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="mid" label="单价" align="center">
						<template slot-scope="scope">
							<span v-if="userInfo.vip">
								<span class="color-red">¥{{ computePrice(scope.row) }}</span>
								<span style="text-decoration: line-through;display: block;">¥{{ scope.row.price }}</span>
							</span>
							<span v-else>
								<span class="color-red">¥{{ scope.row.price }}</span>
							</span>
						</template>
					</el-table-column>
				
					<el-table-column prop="styleid" label="数量" width="150">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.number" :min="1" :max="scope.row.surplus" @change="cartUpdate = true"></el-input-number>
							<div>剩余{{ scope.row.surplus }}件</div>
						</template>
					</el-table-column>
					<el-table-column prop="pic" label="金额" align="center">
						<template slot-scope="scope">
							<span class="color-red">{{ calcSingle(scope.row) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="deleteGoods('single',scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="jiesuan flex">
					<div>
						<el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
						<span class="delete" @click="deleteGoods('multi')">删除选中</span>
					</div>
					<div>
						<span class="span-total">
							总价
							<span class="color-red price-total">{{ calcTotal() }}</span>
							<el-tooltip class="item" effect="dark" content="不包含运费及送装服务费" placement="top-start">
								<i class="el-icon-info" style="color:#ff9d00"></i>
							</el-tooltip>
						</span>
						<el-button type="danger" :disabled="!tselectedIds.length" @click="createOrder">结算</el-button>
					</div>
				</div>
			</template>
			<div v-else class="text-center">
				<template v-if="loaded">
					<img src="../../assets/cart-empty.png" >
					<div>
						购物车是空的哦
						<el-link style="margin-left: 10px;color: red;" @click="toPage('/home')">去逛逛>></el-link>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import Cookie from 'js-cookie';
import { mapState, mapMutations, mapActions } from 'vuex';
import commonHeader from '../../components/common/commonHeader.vue';
export default {
	components: {
		commonHeader
	},
	name: '',
	data() {
		return {
			total: 0, //总价格
			allChecked: false, //全选状态  true|false
			empty: false, //空白页现实  true|false
			cartList: [],
			cartUpdate: false,
			checkAll: false,
			tselectedIds: [],
			loaded:false,
		};
	},
	mounted() {
		this.loadData();
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	methods: {
		computePrice(goods) {
			var price;
			if (goods.zhekouType == 1) {
				price = Number((goods.price * this.userInfo.vipZhekou * 100) / 100).toFixed(2);
			} else {
				price = goods.vipprice;
			}
			return price;
		},
		calcSingle(scope) {
			let goods_pay;
			if (this.userInfo.vip) {
				if (scope.zhekouType == 1) {
					goods_pay = (scope.price * this.userInfo.vipZhekou * 100 * scope.number) / 100;
				} else {
					goods_pay = scope.vipprice * scope.number;
				}
			} else {
				goods_pay = scope.price * scope.number;
			}
			return goods_pay.toFixed(2);
		},
		loadData() {
			this.$emit('showLoading', true);
			this.$request
				.post('/home.cart/cartList', {
					userid: this.userInfo.id ? this.userInfo.id : '',
					token: this.userInfo.token ? this.userInfo.token : ''
				})
				.then(res => {
					console.log(res.data);
					this.$emit('showLoading', false);
					if (res.data.status == 0) {
						this.loaded = true;
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						let list = res.data.list;
						let cartList = list.map(item => {
							item.checked = false;
							return item;
						});
						let sorts = res.data.sort_key;
						let newList = [];
						for (let i in sorts) {
							for (let j in cartList) {
								if (cartList[j].id == sorts[i]) {
									newList = newList.concat(cartList[j]);
								}
							}
						}
						setTimeout(() => {
							this.cartList = newList;
							this.loaded = true;
							console.log(JSON.stringify(this.cartList));
							this.calcTotal(); //计算总价
						}, 500);
					}
				})
				.catch(err => {
					console.log(err);
					this.$emit('showLoading', false);
					this.loaded = true;
				});
		},
		rowSelect(selection, row) {
			if (row.children) {
				//只对有子节点的行响应
				if (!row.checked) {
					//由行数据中的元素checked判断当前是否被选中
					row.children.map(item => {
						//遍历所有子节点
						this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
						item.checked = true;
						let i = this.tselectedIds.indexOf(item.id);
						if (i == -1) {
							this.tselectedIds.push(item.id);
						}
					});

					row.checked = true; //当前行checked标志元素切换为true
					let i = this.tselectedIds.indexOf(row.id);
					if (i == -1) {
						this.tselectedIds.push(row.id);
					}
				} else {
					row.children.map(item => {
						this.$refs.multipleTable.toggleRowSelection(item, false);
						item.checked = false;
						let i = this.tselectedIds.indexOf(item.id);
						if (i !== -1) {
							this.tselectedIds.splice(i, 1);
						}
					});
					row.checked = false;
					let i = this.tselectedIds.indexOf(row.id);
					if (i !== -1) {
						this.tselectedIds.splice(i, 1);
					}
				}
			} else {
				console.log(row);
				if (!row.checked) {
					row.checked = true;
					let i = this.tselectedIds.indexOf(row.id);
					if (i == -1) {
						this.tselectedIds.push(row.id);
					}
				} else {
					row.checked = false;
					let i = this.tselectedIds.indexOf(row.id);
					if (i !== -1) {
						this.tselectedIds.splice(i, 1);
					}
					// 切换父节点选中状态
					if (row.upid) {
						this.cartList.map(item => {
							if (item.id == row.upid) {
								console.log(item.id);
								this.$refs.multipleTable.toggleRowSelection(item, false);
								item.checked = false;
								let i = this.tselectedIds.indexOf(item.id);
								if (i !== -1) {
									this.tselectedIds.splice(i, 1);
								}
							}
						});
					}
				}
			}
			console.log(this.tselectedIds);
		},
		selectAll(selection) {
			this.tselectedIds = [];
			console.log(selection);
			if (selection.length == this.cartList.length) {
				this.checkAll = true;
			} else {
				this.checkAll = false;
			}
			// selection 是选中的数据集合
			this.$refs.multipleTable.data.map(items => {
				//使用$ref获取注册的子组件信息，用data获取所有行，并用map函数遍历行
				if (this.checkAll) {
					//若遍历出来的行未选中
					this.$refs.multipleTable.toggleRowSelection(items, true); //行变为选中状态
					items.checked = true; //更新标志参数
					let i = this.tselectedIds.indexOf(items.id);
					if (i == -1) {
						this.tselectedIds.push(items.id);
					}
					if (items.children) {
						items.children.map(item => {
							//遍历子节点并改变状态与标志参数
							this.$refs.multipleTable.toggleRowSelection(item, true);
							item.checked = true;
							let i = this.tselectedIds.indexOf(item.id);
							if (i == -1) {
								this.tselectedIds.push(item.id);
							}
						});
					}
				} else {
					//若遍历出来的行未选中
					this.$refs.multipleTable.toggleRowSelection(items, false); //行变为选中状态
					items.checked = false; //更新标志参数
					let i = this.tselectedIds.indexOf(items.id);
					if (i !== -1) {
						this.tselectedIds.splice(i, 1);
					}
					if (items.children) {
						items.children.map(item => {
							//遍历子节点并改变状态与标志参数
							this.$refs.multipleTable.toggleRowSelection(item, false);
							item.checked = false;
							let i = this.tselectedIds.indexOf(item.id);
							if (i !== -1) {
								this.tselectedIds.splice(i, 1);
							}
						});
					}
				}
			});
			console.log(this.tselectedIds);
		},
		checkAllChange() {
			// selection 是选中的数据集合
			this.$refs.multipleTable.data.map(items => {
				//使用$ref获取注册的子组件信息，用data获取所有行，并用map函数遍历行
				if (this.checkAll) {
					//若遍历出来的行未选中
					this.$refs.multipleTable.toggleRowSelection(items, true); //行变为选中状态
					items.checked = true; //更新标志参数
					let i = this.tselectedIds.indexOf(items.id);
					if (i == -1) {
						this.tselectedIds.push(items.id);
					}
					if (items.children) {
						items.children.map(item => {
							//遍历子节点并改变状态与标志参数
							this.$refs.multipleTable.toggleRowSelection(item, true);
							item.checked = true;
							let i = this.tselectedIds.indexOf(item.id);
							if (i == -1) {
								this.tselectedIds.push(item.id);
							}
						});
					}
				} else {
					//若遍历出来的行未选中
					this.$refs.multipleTable.toggleRowSelection(items, false); //行变为选中状态
					items.checked = false; //更新标志参数
					let i = this.tselectedIds.indexOf(items.id);
					if (i !== -1) {
						this.tselectedIds.splice(i, 1);
					}
					if (items.children) {
						items.children.map(item => {
							//遍历子节点并改变状态与标志参数
							this.$refs.multipleTable.toggleRowSelection(item, false);
							item.checked = false;
							let i = this.tselectedIds.indexOf(item.id);
							if (i !== -1) {
								this.tselectedIds.splice(i, 1);
							}
						});
					}
				}
			});
			console.log(this.tselectedIds);
		},
		//计算总价
		calcTotal() {
			let list = this.cartList;
			if (list.length === 0) {
				this.empty = true;
				return '0.00';
			}
			let total = 0;
			let checked = true;
			list.forEach(item => {
				if (item.checked === true) {
					var goods_pay = 0;
					if (this.userInfo.vip) {
						if (item.zhekouType == 1) {
							goods_pay = (item.price * this.userInfo.vipZhekou * item.number *100)/100;
						} else {
							goods_pay = item.vipprice * item.number;
						}
					} else {
						goods_pay = item.price * item.number;
					}
					goods_pay = goods_pay.toFixed(2);
					item.realpay = goods_pay;
					total += Number(goods_pay);
				} else if (checked === true) {
					checked = false;
				}
			});
			this.allChecked = checked;
			this.total = Number(total.toFixed(2));
			return this.total.toFixed(2);
		},
		deleteGoods(multi,scope='',index=''){
			if(multi=='multi'&&!this.tselectedIds.length){
				this.$message.error('尚未选中任何商品');
				return false;
			}
			this.$confirm('是否要删除当前选中商品？')
			.then(_=>{
				this.$emit('showLoading',true);
				this.$request
					.post('/home.cart/deleteCartGoods', {
						multi:multi,
						goodsid: multi=='multi'?this.tselectedIds:scope.id,
						userid: this.userInfo.id ? this.userInfo.id : '',
						token: this.userInfo.token ? this.userInfo.token : ''
					})
					.then(res => {
						console.log(res.data);
						this.$emit('showLoading',false);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'userinfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							if(multi=='multi'){
								this.loadData();
							}else{
								this.cartList.splice(index,1);
							}
						}
					})
					.catch(err => {
						this.$emit('showLoading',false);
						console.log(err);
					});
			})
			.catch(err=>{
				
			})
		},
		//创建订单
		createOrder() {
			let list = this.cartList;
			let goodsData = [];
			list.forEach(item => {
				if (item.checked) {
					item.parentsId = [item.first_parent_id, item.second_parent_id, item.parent_id];
					goodsData.push(item);
				}
			});
			localStorage.setItem('buyList_'+this.userInfo.id,JSON.stringify(goodsData));
			localStorage.setItem('buyTotal_'+this.userInfo.id,this.total);
			this.$router.push({path:'/order/createOrder',query:{jumpfrom:'cart'}});
		},
	},
	beforeDestroy() {
		console.log('updateCart');
		if (this.cartUpdate) {
			this.cartUpdate = false;
			// 更新购物车数据库
			let list = this.cartList;
			let cartinfo = {};
			list.forEach(item => {
				let id = item.id;
				cartinfo['goods' + id] = parseInt(item.number);
			});
			this.$request
				.post('/home.cart/updateCart', {
					cartinfo: cartinfo,
					user_id: this.userInfo.id ? this.userInfo.id : '',
					userid: this.userInfo.id ? this.userInfo.id : '',
					token: this.userInfo.token ? this.userInfo.token : ''
				})
				.then(res => {
					console.log(res.data);
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
	
};
</script>
<style lang="scss">
.container {
	position: relative;
	.goods-info {
		.el-image {
			width: 100px;
			height: 100px;
			flex-shrink: 0;
			img {
				width: 100px;
				height: 100px;
			}
		}
		.title {
			padding: 0 10px;
			.param {
				font-size: 13px;
				color: gray;
			}
			.title-name {
				cursor: pointer;
				&:hover {
					text-decoration: underline;
					color: #fa436a;
				}
			}
		}
	}
	.jiesuan {
		position: fixed;
		min-width: 960px;
		width: calc(100vw - 280px);
		max-width: 1160px;
		height: 50px;
		line-height: 50px;
		background-color: #f7f7f7;
		bottom: 0;
		z-index: 9;
		padding-left: 10px;
		.span-total {
			padding: 0 15px;
		}
		.price-total {
			padding: 0 15px;
			font-size: 18px;
			font-weight: bold;
			&::before {
				content: '￥';
				font-size: 15px;
			}
		}
		.delete {
			margin: 0 15px;
			text-decoration: underline;
			color: #f56c6c;
			font-size: 14px;
			&:hover {
				cursor: pointer;
			}
		}
	}
}
</style>
